import { Injector } from '@angular/core';
import { Components } from '@formio/angular';
import { FormioCustomComponentInfo, registerExternalCustomFormioComponents } from '@pics-core/dynamic';
import { CustomSelectComponent } from './custom-select.component';

const editForm = Components.components.select.editForm();
editForm.components[0].components.push({
  label: 'Configuration',
  key: 'configuration',
   components: [
         {
      label: 'Read Only Condition',
      applyMaskOn: 'change',
      autoExpand: false,
      tableView: true,
      key: 'customOptions.readOnlyCondition',
      type: 'textarea',
      placeholder: 'Example: readOnlyCondition : data.action === \'view\'',
      rows: 4,
      input: true
    },
   ],
});

const COMPONENT_OPTIONS: FormioCustomComponentInfo = {
  type: 'customEducationSelect',
  selector: 'app-custom-select',
  group: 'advanced',
  title: 'Education Level Select',
  icon: 'graduation-cap',
  fieldOptions: ['value', 'form', 'description', 'disabled', 'name'],
  editForm: () => editForm,
  changeEvent: 'valueChange'
};

export function registerCustomEducationSelectComponent(injector: Injector) {
  try {
    registerExternalCustomFormioComponents(COMPONENT_OPTIONS, CustomSelectComponent, injector);
    console.log('Custom Education Select Component Registration Done');
  } catch (error) {
    console.log('Error in register custom education select component:', error);
  }
}
